import { Box, Button, Card, Container, Grid, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import TableStyle from 'src/components/TableStyle';
import moment from 'moment';
import { commonUtils } from '../utils/utils';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardData } from '../redux/slice/dashboardSlice';
import { fetchProjectData } from '../redux/slice/projectSlice';
import { fetchUserData } from '../redux/slice/userSlice';
import { CiExport } from "react-icons/ci";

import {
  AppCurrentVisits,
  AppWebsiteVisits,
} from '../sections/@dashboard/app';


export default function AccountingPage() {
    const theme = useTheme();
    // const [userAction, setUserAction] = useState(null)
    const userData = useSelector((state) => state?.userDetails?.data)
    const { data, isLoading } = useSelector((state) => state?.projectDetails)
    const accountingdata = useSelector((state) => state?.dashboardDetails?.data)
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRowIds, setSelectedRowIds] = useState([]);

    function CustomToolbar() {    
      return (
        <GridToolbarContainer>
          <Box padding={"10px 0"}>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector
              slotProps={{ tooltip: { title: 'Change density' } }}
            />
              </Box>
        </GridToolbarContainer>
      );
    }
    const columns = [
        {
          field: "projectNumber",
          headerName: "Project Number",
          width: 300,
          cellClassName: "name-column--cell",
        },
        {
          field: "projectType",
          headerName: "Project Type",
          width: 300,
        },
        {
          field: "clientName",
          headerName: "Client",
          width: 300,
        },
        {
          field: "projectStartDate",
          headerName: "Project Start Date",
          width: 300,
          valueFormatter: (params) => {
            const date = new Date(params.value);
            return date.toDateString();
          },
        },
        {
          field: "projectEndDate",
          headerName: "Project End Date",
          width: 300,
          valueFormatter: (params) => {
            const date = new Date(params.value);
            return date.toDateString();
          },
        },
        {
          field: "projectStatus",
          headerName: "Project Status",
          width: 300,
        },
        {
            field: "projectCost",
            headerName: "Project Cost",
            width: 300,
        },
        {
          field: "feeEarned",
          headerName: "feeEarned Earned",
          width: 300,
        }
      ];
    
      const csvColumns = [
        { Header: "Project Number", accessor: 'projectNumber' },
        { Header: "Project Type", accessor: 'projectType' },
        { Header: "Client", accessor: "clientName" },
        { Header: "Project Start Date", accessor: 'projectStartDate', type: 'date' },
        { Header: "Project End Date", accessor: 'projectEndDate', type: 'date' },
        { Header: "Project Status", accessor: 'projectStatus' },
        { Header: "Project Cost", accessor: 'projectCost' },
        { Header: "feeEarned Earned", accessor: 'feeEarned' },
      ];
      const handleClose = () => {
        setAnchorEl(null);
      };
      const downloadCsvOrExcel = async (extension, selectedIds) => {
        const formatDateOfBirth = (dateString, filednm) => {
          return moment(dateString).format('DD/MM/YYYY HH:MM A')
        };
    
        const formatRecords = (records) => {
          return records.map((rec) => {
            const selectedFieldsData = {};
            csvColumns?.forEach((item) => {
              if (item?.type === 'date') {
                selectedFieldsData[item?.accessor] = formatDateOfBirth(rec[item?.accessor]);
              }
              else {
                selectedFieldsData[item?.accessor] = rec[item?.accessor];
              }
            });
            return selectedFieldsData;
          });
        };
    
        if (selectedIds && selectedIds?.length > 0) {
          const selectedRecordsWithSpecificFileds = formatRecords(data?.filter((rec) => selectedIds?.includes(rec._id)));
          commonUtils.convertJsonToCsvOrExcel({ jsonArray: selectedRecordsWithSpecificFileds, csvColumns, fileName: "Project", extension, setSelectedRowIds });
        } else {
          const AllRecordsWithSpecificFileds = formatRecords(data);
          commonUtils.convertJsonToCsvOrExcel({ jsonArray: AllRecordsWithSpecificFileds, csvColumns, fileName: "Project", extension, setSelectedRowIds });
        }
      };
      const handleExportProject = (extension) => {
        if (selectedRowIds && selectedRowIds?.length > 0) {
          downloadCsvOrExcel(extension, selectedRowIds)
        } else {
          downloadCsvOrExcel(extension);
        }
      };

      useEffect(() => {
        if (userData?.length === 0) {
          dispatch(fetchUserData())
        }
        if (accountingdata?.length === 0) {
          dispatch(fetchDashboardData())
        }
        dispatch(fetchProjectData())
      }, [])
      
    return (
        <>
          <Helmet>
            {/* <title> Dashboard | Minimal UI </title> */}
          </Helmet>
    
          <Container maxWidth="xl">
            <Typography variant="h4" sx={{ mb: 5 }}>
              Accounting Information
            </Typography>
    
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={8}>
                <AppWebsiteVisits
                  title="Monthly feeEarneds"
                  subheader="Chart"
                  chartLabels={accountingdata?.feeEarnedkeys || []}
                  chartData={[
                    {
                      name: 'feeEarned',
                      type: 'column',
                      fill: 'solid',
                      data: accountingdata?.feeEarnedvalues || [],
                    },
                  ]}
                />
              </Grid>
    
              <Grid item xs={12} md={6} lg={4}>
                <AppCurrentVisits
                  title="Acquired Policies"
                  chartData={accountingdata?.projects || []}
                  chartColors={[
                    theme.palette.primary.main,
                    theme.palette.info.main,
                    theme.palette.warning.main,
                    theme.palette.error.main,
                  ]}
                />
              </Grid>
              </Grid>
        </Container>
            <Container maxWidth>
            <Grid item xs={12} md={6} lg={8}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Typography variant="h4" >
                Projects
              </Typography>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                <Button variant="contained" startIcon={<CiExport icon="eva:plus-fill" />} onClick={() => { handleClose(); handleExportProject('xlsx') }}>
                  {selectedRowIds && selectedRowIds?.length > 0 ? 'Export Selected Data' : 'Export'}
                </Button>
              </Stack>
            </Stack>
                  <TableStyle>
              <Box width="100%">
                {isLoading ? (
                  <Card style={{ display: 'flex', justifyContent: 'center', height: "600px" }}>
                    <span className="loader" />
                  </Card>
                ) : (
                  <Card style={{ height: "600px" }}>
                    <DataGrid
                      rows={data || []}
                      columns={columns}
                      components={{ Toolbar: () => CustomToolbar() }}
                      checkboxSelection
                      rowSelectionModel={selectedRowIds}
                      getRowId={row => row._id}
                    />
                  </Card>
                )}
              </Box>
            </TableStyle>
            </Grid>
            </Container>
            </>
      );
}